import styled, { css } from 'styled-components';
import CountUp from 'react-countup';
import { shade } from 'polished';

import { Link as LinkBase } from 'react-router-dom';

export const Icon = styled.div`
  display: flex;
  width: 5rem !important;
  align-items: row;
  justify-content: center;
  align-items: flex-start !important;
  transition: all 0.2s ease-in-out;
  color: #fff;
  svg {
    font-size: 38px;
    stroke-width: 1px;
    position: absolute;
    transition: all 0.2s ease-in-out;

    margin-left: ${props =>
      props.type === 'mini'
        ? '5px'
        : props.type === 'condensed'
        ? props.$inverted
          ? '1.3rem'
          : '0.3rem'
        : '0.55rem'};
  }

  &::before {
    transition: all 0.2s ease-in-out;
    /* z-index: 1; */
    content: '';
    height: 55px;
    width: 55px;
    border-radius: 50%;


    ${props =>
      props.type === 'mini' &&
      css`
        border-radius: 0px 50% 50% 0;
      `}

    ${props =>
      props.type === 'condensed' &&
      css`
        border-radius: ${props =>
          props.$inverted ? '50% 0 0 50%' : '0px 50% 50% 0'};

        height: 100px;
        width: 100px;

        margin-left: ${props => (props.$inverted ? '0' : '-33px')};
      `}


    ${props =>
      props.color === 'success'
        ? css`
            background: ${props.theme.button.success.out};
            background-image: -webkit-gradient(
              linear,
              right top,
              left bottom,
              from(${props.theme.button.success.out}),
              color-stop(${props.theme.button.success.in}),
              to(${props.theme.button.success.out})
            );
            background-image: linear-gradient(
              to bottom left,
              ${props.theme.button.success.out},
              ${props.theme.button.success.in},
              ${props.theme.button.success.out}
            );
          `
        : props.color === 'done'
        ? css`
            background: ${props.theme.button.success.out};
            background-image: -webkit-gradient(
              linear,
              right top,
              left bottom,
              from(${props.theme.button.done.out}),
              color-stop(${props.theme.button.done.in}),
              to(${props.theme.button.done.out})
            );
            background-image: linear-gradient(
              to bottom left,
              ${props.theme.button.done.out},
              ${props.theme.button.done.in},
              ${props.theme.button.done.out}
            );
          `
        : props.color === 'warn'
        ? css`
            background: ${props.theme.button.warn.out};
            background-image: -webkit-gradient(
              linear,
              right top,
              left bottom,
              from(${props.theme.button.warn.out}),
              color-stop(${props.theme.button.warn.in}),
              to(${props.theme.button.warn.out})
            );
            background-image: linear-gradient(
              to bottom left,
              ${props.theme.button.warn.out},
              ${props.theme.button.warn.in},
              ${props.theme.button.warn.out}
            );
          `
        : props.color === 'info'
        ? css`
            background: ${props.theme.button.primary.out};
            background-image: -webkit-gradient(
              linear,
              right top,
              left bottom,
              from(${props.theme.button.primary.out}),
              color-stop(${props.theme.button.primary.in}),
              to(${props.theme.button.primary.out})
            );
            background-image: linear-gradient(
              to bottom left,
              ${props.theme.button.primary.out},
              ${props.theme.button.primary.in},
              ${props.theme.button.primary.out}
            );
          `
        : props.color === 'danger'
        ? css`
            background: ${props.theme.button.danger.out};
            background-image: -webkit-gradient(
              linear,
              right top,
              left bottom,
              from(${props.theme.button.danger.out}),
              color-stop(${props.theme.button.danger.in}),
              to(${props.theme.button.danger.out})
            );
            background-image: linear-gradient(
              to bottom left,
              ${props.theme.button.danger.out},
              ${props.theme.button.danger.in},
              ${props.theme.button.danger.out}
            );
          `
        : props.color === 'secondary'
        ? css`
            background: ${props.theme.button.danger.out};
            background-image: -webkit-gradient(
              linear,
              right top,
              left bottom,
              from(${props.theme.button.secondary.out}),
              color-stop(${props.theme.button.secondary.in}),
              to(${props.theme.button.secondary.out})
            );
            background-image: linear-gradient(
              to bottom left,
              ${props.theme.button.secondary.out},
              ${props.theme.button.secondary.in},
              ${props.theme.button.secondary.out}
            );
          `
        : css`
            background: ${props.theme.button.default.out};
            background-image: -webkit-gradient(
              linear,
              right top,
              left bottom,
              from(${props.theme.button.default.out}),
              color-stop(${props.theme.button.default.in}),
              to(${props.theme.button.default.out})
            );
            background-image: linear-gradient(
              to bottom left,
              ${props.theme.button.default.out},
              ${props.theme.button.default.in},
              ${props.theme.button.default.out}
            );
          `}

    background-size: 210% 210%;
    background-position: 100% 0;

    background-size: 210% 210%;
    background-position: 100% 0;
  }
`;

export const Container = styled.div`
  border: ${props =>
    props.theme.name === 'dark'
      ? 'none'
      : `2px solid ${props.theme.cardBorder}`};
  background: ${props => props.theme.cardBackgroud};
  height: 150px;
  min-width: 273px;
  padding: ${props => (props.condensed ? '5px 10px' : '15px')};
  border-radius: 5px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  cursor: ${props => (props.condensed ? 'pointer' : 'default')};

  transition: background-color 0.2s ease-in-out;

  ${props =>
    props.type === 'mini' &&
    css`
      position: relative;
      overflow: hidden;
      background: ${props => props.theme.cardBackgroud};
      height: 48px;
      min-width: 140px;
      padding: 5px 10px 5px 0;
      border-radius: 5px;
      width: 100%;
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      cursor: pointer;
    `}

  ${props =>
    props.type === 'condensed' &&
    css`
      position: relative;
      overflow: hidden;
      background: ${props => props.theme.cardBackgroud};
      height: 82px;
      min-width: 180px;
      padding: 5px 10px;
      border-radius: 5px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      cursor: pointer;
    `}

  margin-left: 10px;
  &:first-of-type {
    margin-left: 0;
  }

  ${props =>
    props.theme.name === 'dark'
      ? css`
          box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1);
        `
      : css`
          box-shadow: 0 1px 15px 0 hsla(0, 0%, 48.2%, 0.05);
        `}

  hr {
    margin: 5px 0;
    border-bottom: 0.1px solid ${props => props.theme.fontColor};
    opacity: 0.4;
  }

  ${props =>
    props.$active &&
    css`
      border: ${props.theme.button.primary.in} 3px solid;
    `}

  &:hover {
    background-color: ${props => shade(0.1, props.theme.cardBackgroud)};
    ${Icon} {
      &::before {
        transform: scale(2);
      }
      svg {
        transform: translateX(20px) scale(1.5);
      }
    }
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: ${props => (props.$inverted ? 'row-reverse' : 'row')};
  justify-content: space-between;
  div {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: ${props => (props.$inverted ? 'flex-start' : 'flex-end')};

    justify-content: center;

    p {
      opacity: 0.8;
      font-size: clamp(0.45rem, 1.5vw, 0.95rem);
      text-align: end;
    }
    p:last-of-type {
      font-size: clamp(0.45rem, 0.75vw, 0.75rem) !important;
      font-style: italic !important;
    }
    span {
      font-size: ${props =>
        props.type !== 'normal'
          ? ' clamp(1.5rem, 1.5vw, 2rem)'
          : 'clamp(1.65rem, 1.5vw, 2.65rem)'};
      font-weight: 300;
      opacity: 1;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;

  svg {
    color: ${props => props.theme.fontColor};
    margin-right: 5px;
    opacity: 0.8;
  }
`;

export const Link = styled(LinkBase)`
  text-decoration: none;
  color: ${props => props.theme.fontColor};
  padding: 0;
  margin: 0;
  transition: all 0.2s ease;
  opacity: 0.8;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
`;

export const Count = styled(CountUp)`
  font-size: 2.65rem;
  font-weight: 300;
  opacity: 0.9;
`;
